import { TTBackboneView } from '@/views/TTBackboneView';
import { SignInController } from '@/views/portal/sign_in/SignInController';
import { HeaderUploadResumeWidget } from '@/views/portal/header/HeaderUploadResumeWidget';
import { ServiceCaller } from '@/services/ServiceCaller';
import { TTAPI } from '@/services/TimeTrexClientAPI';

export class HeaderViewController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {
			events: {
				'click .navbar-signin .login': 'goPortalLogin',
				'click .navbar-signin .logout': 'doLogout',
				'click .navbar-signin .profile': 'goProfile'
				// 'click .navbar-upload-resume > a': 'uploadResume'
			}
		} );

		super( options );
	}

	initialize( options ) {
		super.initialize( options );
		var url;
		var options = {};
		if ( LocalCacheData.getAllURLArgs().company_id ) {
			url = ServiceCaller.getAPIURL( 'Class=APIDocumentPortal&Method=getCompanyLogo' + '&v=2' ) + '&company_id=' + LocalCacheData.getAllURLArgs().company_id;
		} else {
			url = '../../theme/default/portal/images/t_icon_logo.png';
		}
		var tpl = Global.loadWidget( 'views/portal/header/HeaderView.html' );
		let portal_vacancy_url = Global.getBaseURL() + '#!m=PortalJobVacancy&company_id=' + LocalCacheData.getAllURLArgs().company_id;
		this.setElement( _.template( tpl )( { company_logo: url, portal_vacancy_link: portal_vacancy_url } ) );
		this.uploadResumeWidget = null;
		this.profileView = null;
		this.jobVacancyDetailController = null;
		this.jobVacancyViewController = null;
		this.render();
	}

	render() {
		var $this = this;
		if ( !LocalCacheData.getPortalLoginUser() ) {
			var sign_in_container = $( '<a class="login"></a>' );
			sign_in_container.attr( 'href', 'javascript:;' );
			sign_in_container.append( $( '<img>' ).attr( 'src', '../../theme/default/portal/images/t_icon_head.png' ) );
			sign_in_container.append( $( '<span>' ).text( $.i18n._( 'Sign In' ) ) );
			this.$( '.navbar-signin' ).html( sign_in_container );
		} else {
			var my_profile_container = $( '<div class="dropdown"></div>' );
			my_profile_container.append( '<div class="dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">' + LocalCacheData.getPortalLoginUser().first_name + ' ' + LocalCacheData.getPortalLoginUser().last_name + ' <span class="caret"></span></div>' );
			var dropdown_menus = $( '<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton"></ul>' );
			dropdown_menus.append( '<li><a class="profile" href="javascript:;">'+ $.i18n._( 'My Profile' ) +'</a></li>' );
			dropdown_menus.append( '<li><a class="logout" href="javascript:;">'+ $.i18n._( 'Sign Out' ) +'</a></li>' );
			my_profile_container.append( dropdown_menus );
			this.$( '.navbar-signin' ).html( my_profile_container );
		}
	}

	goPortalLogin() {
		var sign_controller = new SignInController( {
			_delegate: this.jobVacancyDetailController
		} );
		// $('#signinModal').modal({
		// 	backdrop: 'static',
		// 	show: true
		// });
	}

	doLogout() {
		this.clearErrorTips();
		var $this = this;
		var current_user_api = TTAPI.APIRecruitmentAuthentication;
		current_user_api.Logout( {
			onResult: function( result ) {
				deleteCookie( Global.getSessionIDKey() );
				LocalCacheData.setPortalLoginUser( false );
				LocalCacheData.current_open_view_id = ''; //#1528  -  Logout icon not working.

				if ( $this.jobVacancyViewController ) {
					$this.render();
				} else {
					if ( window.location.href.indexOf('#!m=PortalJobVacancy&') !== -1 ) {
						IndexViewController.instance.router.headerView.render(); //Ensure the Profile button at the top right switches back to "Sign In"
					} else {
						var url = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=PortalJobVacancy$1').replace( Global.getBaseURL( null, true, false ), '' ); //Be sure to include any other URL args.
						IndexViewController.instance.router.navigate( url, {
							trigger: true,
							replace: true
						} );
					}
				}
			}
		} );
	}

	//needed for logout.
	clearErrorTips() {
		//harder here because we can't access the active controller's data from here.
		Global.removeErrorTips( document.querySelectorAll( '.error-tip' ), true );
	}

	goProfile() {
		window.location = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=MyProfile$1').replace( /&id=[^&]*/g, '' ); //Be sure to include any other URL args.
	}

	uploadResume() {
		var $this = this;
		if ( !LocalCacheData.getPortalLoginUser() ) {
			// IndexViewController.instance.router.showTipModal('Please login first!')
			// setTimeout(function(  ) {
			// 	$this.goPortalLogin();
			// }, 100)
			this.goPortalLogin();
		} else {
			if ( !this.uploadResumeWidget ) {
				this.uploadResumeWidget = new HeaderUploadResumeWidget( {
					profileView: $this.profileView
				} );
			}
			this.uploadResumeWidget.render();
		}
	}
}
